import React, { useState } from 'react';
import Modal from '../../../components/Modal/index';
import DesktopAdExamples from './DesktopAdExamples';
import MobileAdExamples from './MobileAdExamples';
import '../../../../sass/pages/account/ad_example_modal.scss';
import trackEvent from '../../../helpers/gtm/eventPush';

const trackPostAdButton = () => {
  trackEvent({
    category: 'ads',
    action: 'free_bold_options_see_bold_example_post_ad',
  });
};

const ExampleAdModal = ({
  isMobile,
  siteId,
  userType,
  subDirectory,
  loginReturnPath,
  postBoldAd,
  localisations,
}) => {
  const [showDialog, updateShowDialog] = useState(false);

  const close = () => {
    updateShowDialog(false);
  };

  const open = () => {
    updateShowDialog(true);
  };

  return (
    <>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText={localisations.bold_advertising}
          id="bold-advertising-modal"
          initialFocus={
            postBoldAd ? '#modalPriceButton' : '#modalUpgradeButton'
          }
        >
          {!isMobile ? (
            <DesktopAdExamples
              localisations={localisations}
              siteId={siteId}
              userType={userType}
            />
          ) : (
            <MobileAdExamples
              localisations={localisations}
              siteId={siteId}
              userType={userType}
            />
          )}
          <span className="modal__ad-example-upgrade-button">
            {postBoldAd ? (
              <a
                href={`/${subDirectory}/find-postcode3.pl?desc=Bold+Advert&amount=10&scp=N`}
                className="button"
                id="modalPriceButton"
                onClick={trackPostAdButton}
              >
                {localisations.post_a_bold_ad}
              </a>
            ) : (
              <a
                href={`/${subDirectory}/${
                  userType === 'seeker'
                    ? 'get_early_bird.pl'
                    : 'get_bold_advertising.pl'
                }?M_context=${
                  loginReturnPath === '/content/myaccount/myaccount-index/'
                    ? '81'
                    : '79'
                }`}
                className="button"
                id="modalUpgradeButton"
              >
                {localisations.upgrade_now}
              </a>
            )}
          </span>
        </Modal>
      ) : null}
      <span className="upgrade-panel__example-button">
        <span className="upgrade-panel__example-dash"> – </span>
        <button onClick={open} className="button button--link">
          {localisations.see_example}
        </button>
      </span>
    </>
  );
};

export default ExampleAdModal;
